import './styles.scss'

import { ChevronLeftIcon } from 'components/Icons'

import CustomButton from './index'

const B2becButtonIcon = ({ icon: IconComponent, children, ...props }) => {
  return (
    <CustomButton {...props}>
      <IconComponent className="custom-button__icon" />
      {children}
    </CustomButton>
  )
}

export const B2becButtonBack = (props) => {
  return <B2becButtonIcon icon={ChevronLeftIcon} {...props} />
}

export default B2becButtonIcon
